import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import ImportCustomersExcel from "pages/Sales/Customers/ImportCustomersExcel";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function ExportCustomer({}) {
  /*   All States
   ********************************************* */
  const user = useSelector((state) => state?.user?.userInfo);
  const dispatch = useDispatch();

  const [allCustomersData, setAllCustomersData] = useState(null);

  /*   All Functions
   ********************************************* */

  const [loading, setLoading] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  const getCustomers = async () => {
    try {
      loadingOn();

      const { data } = await API.get("/customers", {
        headers: authHeader(),
      });

      setAllCustomersData(data);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      loadingOff();
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      getCustomers();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="mt-3">
      {/* Customer Option Card */}
      <div className="card">
        <div className="card-body">
          {loading && <Spinner />}
          {/* Import Section */}
          {allCustomersData && (
            <ImportCustomersExcel
              allCustomersData={allCustomersData}
              setAllCustomersData={setAllCustomersData}
              refreshFunc={getCustomers}
            />
          )}
        </div>
      </div>
    </div>
  );
}
